import React from 'react'
import styled, { css } from 'styled-components'
import { responsive } from '../../utils/responsive'

const StyledStack = styled.div`
  display: flex;
  ${(p) => responsive('flex-direction', p.$direction || 'row', p.theme)}
  ${(p) => responsive('gap', typeof p.$gap === 'number' ? `${p.$gap}px` : (p.$gap || p.theme.space.md), p.theme)}
  ${(p) => p.$align && responsive('align-items', p.$align, p.theme)}
  ${(p) => p.$justify && responsive('justify-content', p.$justify, p.theme)}
  width: ${(p) => (p.$full ? '100%' : 'auto')};
`

export function Stack({ children, direction = 'row', gap = '12px', align, justify, fullWidth }) {
  return (
    <StyledStack $direction={direction} $gap={gap} $align={align} $justify={justify} $full={fullWidth}>
      {children}
    </StyledStack>
  )
}
